class CustomerAuth extends HTMLElement {
    constructor() {
        super();

        this.auth = this;
        this.storageKey = 'banditos-account-sidebar-open';
        this.persistentViewport =
            window.matchMedia('(min-width: 768px)');

        document
            .querySelectorAll('[data-open-auth-popup]')
            .forEach((openPopup) => {
                openPopup.addEventListener(
                    'click',
                    this.setOpenPopup.bind(this)
                );
            });

        const closePopup = document.querySelector(
            '[data-close-auth-popup]'
        );

        if (closePopup) {
            closePopup.addEventListener(
                'click',
                this.setClosePopup.bind(this)
            );
        }

        document
            .querySelectorAll('[data-open-auth-sidebar]')
            .forEach((openSidebar) => {
                openSidebar.addEventListener(
                    'click',
                    this.setOpenSidebar.bind(this)
                );
            });

        const closeSidebar = this.querySelector(
            '[data-close-auth-sidebar]'
        );

        if (closeSidebar) {
            closeSidebar.addEventListener(
                'click',
                this.setCloseSidebar.bind(this)
            );
        }

        this
            .querySelectorAll('a[href*="/account/logout"]')
            .forEach((logoutLink) => {
                logoutLink.addEventListener(
                    'click',
                    this.clearPersistentState.bind(this)
                );
            });

        document.body.addEventListener(
            'click',
            this.onBodyClickEvent.bind(this)
        );

        this.persistentViewport.addEventListener(
            'change',
            this.onViewportChange.bind(this)
        );

        this.restorePersistentSidebar();
    }

    isLoggedInSidebar() {
        return Boolean(
            this.querySelector('.account-dropdown')
        );
    }

    isPersistentMode() {
        return (
            this.persistentViewport.matches &&
            this.isLoggedInSidebar()
        );
    }

    hasPersistentState() {
        try {
            return (
                sessionStorage.getItem(this.storageKey) === 'true'
            );
        } catch (error) {
            return false;
        }
    }

    savePersistentState() {
        if (!this.isPersistentMode()) {
            return;
        }

        try {
            sessionStorage.setItem(
                this.storageKey,
                'true'
            );
        } catch (error) {
            /*
             * sessionStorage kan in een afgeschermde
             * browseromgeving niet beschikbaar zijn.
             */
        }

        document.documentElement.classList.add(
            'banditos-auth-persistent'
        );
    }

    clearPersistentState() {
        try {
            sessionStorage.removeItem(this.storageKey);
        } catch (error) {
            /*
             * sessionStorage kan in een afgeschermde
             * browseromgeving niet beschikbaar zijn.
             */
        }

        document.documentElement.classList.remove(
            'banditos-auth-persistent'
        );
    }

    restorePersistentSidebar() {
        if (
            this.isPersistentMode() &&
            this.hasPersistentState()
        ) {
            document.documentElement.classList.add(
                'banditos-auth-persistent'
            );

            document.body.classList.add(
                'auth-sidebar-show'
            );

            return;
        }

        if (
            !this.persistentViewport.matches ||
            !this.isLoggedInSidebar()
        ) {
            this.clearPersistentState();
        }
    }

    onViewportChange(event) {
        if (!event.matches) {
            this.clearPersistentState();

            document.body.classList.remove(
                'auth-sidebar-show'
            );

            return;
        }

        if (
            document.body.classList.contains(
                'auth-sidebar-show'
            ) &&
            this.isLoggedInSidebar()
        ) {
            this.savePersistentState();
        }
    }

    setOpenPopup(event) {
        event.preventDefault();
        event.stopPropagation();

        if (
            document.body.classList.contains(
                'template-customers-login'
            )
        ) {
            $('html, body').animate(
                {
                    scrollTop: 0
                },
                700
            );
        } else {
            document.body.classList.add(
                'auth-popup-show'
            );
        }
    }

    setClosePopup(event) {
        event.preventDefault();
        event.stopPropagation();

        document.body.classList.remove(
            'auth-popup-show'
        );
    }

    setOpenSidebar(event) {
        event.preventDefault();
        event.stopPropagation();

        if (
            document.body.classList.contains(
                'template-customers-login'
            )
        ) {
            $('html, body').animate(
                {
                    scrollTop: 0
                },
                700
            );

            return;
        }

        if (this.isPersistentMode()) {
            this.savePersistentState();
        }

        document.body.classList.add(
            'auth-sidebar-show'
        );
    }

    setCloseSidebar(event) {
        event.preventDefault();
        event.stopPropagation();

        this.clearPersistentState();

        document.body.classList.remove(
            'auth-sidebar-show'
        );
    }

    onBodyClickEvent(event) {
        if (
            document.body.classList.contains(
                'auth-popup-show'
            )
        ) {
            const clickedOutsidePopup =
                !this.contains(event.target);

            const clickedPopupButton =
                $(event.target)
                    .closest('[data-open-auth-popup]')
                    .length > 0;

            if (
                clickedOutsidePopup &&
                !clickedPopupButton
            ) {
                this.setClosePopup(event);
            }
        }

        if (
            !document.body.classList.contains(
                'auth-sidebar-show'
            )
        ) {
            return;
        }

        /*
         * Vanaf 768px blijft de ingelogde accountsidebar open.
         * Klikken op de achterliggende pagina sluit hem niet.
         */
        if (this.isPersistentMode()) {
            return;
        }

        /*
         * Onder 768px blijft Ella's oorspronkelijke
         * mobiele sluitgedrag behouden.
         */
        const clickedOutsideSidebar =
            !this.contains(event.target);

        const clickedSidebarButton =
            $(event.target)
                .closest('[data-open-auth-sidebar]')
                .length > 0;

        const clickedSidebarElement =
            $(event.target)
                .closest('[data-auth-sidebar]')
                .length > 0;

        if (
            clickedOutsideSidebar &&
            !clickedSidebarButton &&
            !clickedSidebarElement
        ) {
            event.stopImmediatePropagation();
            this.setCloseSidebar(event);
        }
    }
}

if (!customElements.get('customer-auth')) {
    customElements.define(
        'customer-auth',
        CustomerAuth
    );
}